import React, { useCallback } from "react";
import Button from "../../components/Button";
import { View, Image, ScrollView, useWindowDimensions } from "react-native";
import VStack from "../../ui_atoms/VStack";
import type { Meta, StoryObj } from "@storybook/react";
import { useWebImagePicker } from "../../components/webimages/WebImagePicker";
import Loading from "../../components/Loading";

const ComponentStory = () => {
    const { width, height } = useWindowDimensions();
    const size = Math.min(width, height);
    const [imageUri, setImageUri] = React.useState<string>();
    const [isLoading, setIsLoading] = React.useState<boolean>();

    const chooseImage = useWebImagePicker();
    const onPress = useCallback(async () => {
        setIsLoading(true);
        try {
            const img = await chooseImage();
            if (!img.canceled) {
                setImageUri(img.assets![0].uri);
            }
        } finally {
            setIsLoading(false);
        }
    }, [chooseImage]);

    return (
        <VStack gap={0.5} alignment="center" style={{ width: "100%" }}>
            <Button label="Select image" onPress={onPress} />
            {isLoading && <Loading />}
            {imageUri && (
                <ScrollView>
                    <Image
                        source={{ uri: imageUri }}
                        style={{ width: size, height: size }}
                        resizeMode="contain"
                    />
                </ScrollView>
            )}
        </VStack>
    );
};

const meta = {
    title: "Components/WebImagePicker",
    component: ComponentStory,
    argTypes: {},
    decorators: [
        (StoryFn) => (
            <View style={{ flex: 1, justifyContent: "center", alignItems: "center", padding: 10 }}>
                <StoryFn />
            </View>
        ),
    ],
} satisfies Meta<typeof ComponentStory>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {},
};
